import {
  type UseMutationOptions,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query'

import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationUnpinPostFromSpaceArgs,
} from '@tribeplatform/gql-client/types'

import { useTribeClient } from '../../useTribeClient.js'
import { getPostKey, getPostsKey } from '../../utils/keys/post.key.js'
import { getPinnedPostsKey } from '../../utils/keys/space.key.js'

export const useUnpinPostFromSpace = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUnpinPostFromSpaceArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationUnpinPostFromSpaceArgs>(
    variables => client.posts.unpinFromSpace(variables),
    {
      onSettled: (data, error, variables) => {
        const postKey = getPostKey({ variables: { id: variables?.postId } })
        queryClient.invalidateQueries(postKey)

        const postsKey = getPostsKey()
        queryClient.invalidateQueries(postsKey)

        const pinnedPostsKey = getPinnedPostsKey()
        queryClient.invalidateQueries(pinnedPostsKey)
      },
      ...useMutationOptions,
    },
  )
}
